export default __webpack_public_path__ + "static/media/illustration-algohealth-w.7d6e80dc.png";